"use strict";
/**
 * @typedef Slice
 * @property {number} offset
 * @property {number} length
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseSource = void 0;

var BaseSource = /*#__PURE__*/function () {
  function BaseSource() {
    (0, _classCallCheck2.default)(this, BaseSource);
  }

  (0, _createClass2.default)(BaseSource, [{
    key: "fetch",
    value:
    /**
     *
     * @param {Slice[]} slices
     * @returns {ArrayBuffer[]}
     */
    function () {
      var _fetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(slices) {
        var _this = this;

        var signal,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                signal = _args.length > 1 && _args[1] !== undefined ? _args[1] : undefined;
                return _context.abrupt("return", Promise.all(slices.map(function (slice) {
                  return _this.fetchSlice(slice, signal);
                })));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
    /**
     *
     * @param {Slice} slice
     * @returns {ArrayBuffer}
     */

  }, {
    key: "fetchSlice",
    value: function () {
      var _fetchSlice = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(slice) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throw new Error("fetching of slice ".concat(slice, " not possible, not implemented"));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function fetchSlice(_x2) {
        return _fetchSlice.apply(this, arguments);
      }

      return fetchSlice;
    }()
    /**
     * Returns the filesize if already determined and null otherwise
     */

  }, {
    key: "fileSize",
    get: function get() {
      return null;
    }
  }, {
    key: "close",
    value: function () {
      var _close = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }]);
  return BaseSource;
}();

exports.BaseSource = BaseSource;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFNYUEsVTs7Ozs7Ozs7SUFDWDs7Ozs7OzJGQUtBLGlCQUFZQyxNQUFaO1FBQUE7O1FBQUE7UUFBQTtRQUFBO1VBQUE7WUFBQTtjQUFBO2dCQUFvQkMsTUFBcEIsMkRBQTZCQyxTQUE3QjtnQkFBQSxpQ0FDU0MsT0FBTyxDQUFDQyxHQUFSLENBQ0xKLE1BQU0sQ0FBQ0ssR0FBUCxDQUFXLFVBQUNDLEtBQUQ7a0JBQUEsT0FBVyxLQUFJLENBQUNDLFVBQUwsQ0FBZ0JELEtBQWhCLEVBQXVCTCxNQUF2QixDQUFYO2dCQUFBLENBQVgsQ0FESyxDQURUOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7OztJQU1BOzs7Ozs7Ozs7Z0dBS0Esa0JBQWlCSyxLQUFqQjtRQUFBO1VBQUE7WUFBQTtjQUFBO2dCQUFBLE1BQ1EsSUFBSUUsS0FBSiw2QkFBK0JGLEtBQS9CLG9DQURSOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7OztJQUlBOzs7Ozs7U0FHQSxlQUFZO01BQ1YsT0FBTyxJQUFQO0lBQ0Q7Ozs7MkZBRUQ7UUFBQTtVQUFBO1lBQUE7Y0FBQTtjQUFBO2dCQUFBO1lBQUE7VUFBQTtRQUFBO01BQUEsQzs7Ozs7Ozs7Ozs7O0FBNUJGRyIsIm5hbWVzIjpbIkJhc2VTb3VyY2UiLCJzbGljZXMiLCJzaWduYWwiLCJ1bmRlZmluZWQiLCJQcm9taXNlIiwiYWxsIiwibWFwIiwic2xpY2UiLCJmZXRjaFNsaWNlIiwiRXJyb3IiLCJleHBvcnRzIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2Rpc3QtbW9kdWxlL3NvdXJjZS9iYXNlc291cmNlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19